<template>
  <b-sidebar
    id="sidebar-review-uz-asbo"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ isInnovationMode ? $t('Reject') : $t('Approve or reject') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <b-form
        class="p-2"
        @submit.prevent
      >
        <div
          v-if="uzAsboList.id"
          class="mb-2"
        >
          <div class="d-flex justify-content-between mb-50">
            <span class="text-muted">{{ $t('Period') }}</span>
            <strong>{{ uzAsboList.year }} — {{ $langName(getMonthName(uzAsboList.month)) }}</strong>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ $t('Researchers count') }}</span>
            <strong>{{ uzAsboList.items_count }}</strong>
          </div>
        </div>

        <b-alert
          v-if="!isInnovationMode"
          variant="warning"
          show
          class="p-1"
        >
          <small>{{ $t('uz asbo approve warning') }}</small>
        </b-alert>

        <b-form-group
          :label="$t('Comment')"
          label-for="uz-asbo-comment"
        >
          <b-form-textarea
            id="uz-asbo-comment"
            v-model="comment"
            rows="4"
            :placeholder="$t('Comment')"
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-if="!isInnovationMode"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-2"
            @click="approve(hide)"
          >
            {{ $t('Approve') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            @click="reject(hide)"
          >
            {{ $t('Reject') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getMonthName } from './config'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    uzAsboList: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: 'org-head',
    },
  },
  data() {
    return {
      comment: '',
    }
  },
  computed: {
    isInnovationMode() {
      return this.mode === 'innovation'
    },
  },
  watch: {
    uzAsboList() {
      this.comment = ''
    },
  },
  methods: {
    getMonthName,
    done(hide) {
      hide()
      this.comment = ''
      this.$emit('refetchData')
    },
    approve(hide) {
      this.$removeSwal(this, {
        id: this.uzAsboList.id,
        comment: this.comment,
      }, 'uzAsbo/approve', () => this.done(hide), {
        title: 'Are you sure?',
        text: 'uz asbo approve warning',
        confirmButtonText: 'Approve',
        successTitle: 'Success',
        successText: 'Successfully completed',
        errorText: 'There was an error in successful execution',
      })
    },
    reject(hide) {
      if (!this.comment) {
        this.$bvToast.toast(this.$t('Comment is required for rejection'), {
          variant: 'danger',
          solid: true,
          title: this.$t('Error'),
        })
        return
      }
      const action = this.isInnovationMode ? 'uzAsbo/innovationReject' : 'uzAsbo/reject'
      this.$removeSwal(this, {
        id: this.uzAsboList.id,
        comment: this.comment,
      }, action, () => this.done(hide), {
        title: 'Are you sure?',
        text: '',
        confirmButtonText: 'Reject',
        successTitle: 'Success',
        successText: 'Successfully completed',
        errorText: 'There was an error in successful execution',
      })
    },
  },
}
</script>
